import axios from "axios";
import { API_BASE_URL as API } from "@/config/api";
export const draftKey = (user, id) => `toss-draft:${user}:${id}`;
export function localDrafts(user) {
  const rows=[];
  for(let i=0;i<localStorage.length;i++) {
    const key=localStorage.key(i);
    if(key.startsWith(`toss-draft:${user}:`)) {
      try { rows.push(JSON.parse(localStorage.getItem(key))); } catch {}
    }
  }
  return rows;
}
export async function forkAssessment(id, revision, user) {
  const {data:a}=await axios.get(`${API}/assessments/${id}`);
  const source=a.original_inputs || {...a, stage_inputs:a.results?.source_stage_inputs || a.stage_inputs, stage_input_units:a.results?.source_stage_input_units || a.stage_input_units};
  const payload={form:{product_name:revision?a.product_name:`${a.product_name} (copy)`,product_type:a.product_type,functional_unit:a.functional_unit,bom_items:a.bom_items},
    stageInputs:source.stage_inputs || {},stageInputUnits:source.stage_input_units || {},transparency:a.transparency || {},applicability:a.applicability || {},calculators:a.calculators || {},step:1,
    sourceAssessmentId:id,revisionOf:revision?id:null};
  const draftId=crypto.randomUUID();
  const row={id:draftId,payload,updated_at:new Date().toISOString()};
  localStorage.setItem(draftKey(user,draftId),JSON.stringify(row));
  await axios.put(`${API}/drafts/${draftId}`,{payload});
  return draftId;
}
